import { Table, TableContainer } from "@mui/material";
import { SortConfig, TableHeader, TableHeaderItem } from "./TableHeader";
import { TableContent } from "./TableContent";
import { Box } from "@mui/system";
import { commonTableStyles as styles } from "./tableStyles";
import UserTableBody from "./UserTableBody";
interface TableProps {
  columns: TableHeaderItem[];
  handleSort: (id: string) => void;
  sortConfig: SortConfig;
  data: Record<string, any>[] | any[];
  onItemPress?: Function;
  isLoading?: boolean;
  tableType?: string;
  userTableFunctions?:any
}
const CustomTable = ({
  columns,
  handleSort,
  sortConfig,
  data,
  onItemPress,
  isLoading = false,
  tableType,
  userTableFunctions={}
}: TableProps) => {
  return (
    <Box sx={styles.paper}>
      <TableContainer>
        <Table sx={styles.table}>
          <TableHeader
            columns={columns}
            handleSort={handleSort}
            currentSortConfig={sortConfig}
          />
          {tableType === "user" ? (
            <UserTableBody userTableFunctions={userTableFunctions} />
          ) : (
            <TableContent
              onItemPress={(item: any) => {
                onItemPress && onItemPress(item);
              }}
              data={data}
              columns={columns}
              isLoading={isLoading}
            />
          )}
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CustomTable;
